import React from 'react'
import MarkdownPage from '../components/MarkdownPage'

export default function Home(){
  return <MarkdownPage name="home" />
}
